import Sorter from "../../../model/Sorter"
import { getAgeZScore, getSalesZScore } from "../../../util/productUtil"
import ProductMetrics from "../../../model/ProductMetrics"
import { ProductType } from "model"

const RecommendedSorter: Sorter = {
  label: "Recommended",
  id: "recommended",
  sort: (products): ProductType[] => {
    return products
    // const sortedProducts = [...products]
    // const salesMetrics = getSalesMetrics(products)
    // const ageMetrics = getAgeMetrics(products)
    //
    // sortedProducts.sort((productA, productB) => {
    //   const aScore = getScore(productA, salesMetrics, ageMetrics)
    //   const bScore = getScore(productB, salesMetrics, ageMetrics)
    //
    //   if (productA.menuOrder > productB.menuOrder) {
    //     return 1
    //   }
    //
    //   if (productB.menuOrder > productA.menuOrder) {
    //     return -1
    //   }
    //
    //   if (aScore < bScore) {
    //     return -1
    //   }
    //
    //   if (aScore > bScore) {
    //     return 1
    //   }
    //
    //   return 0
    // })
    //
    // return sortedProducts
  },
}

const getScore = (
  product: ProductType,
  salesMetrics: ProductMetrics,
  ageMetrics: ProductMetrics
) => {
  const salesScore = getSalesZScore(product, salesMetrics)
  const ageScore = getAgeZScore(product, ageMetrics)
  return salesScore + ageScore
}

export default RecommendedSorter
